<template>
  <div>
    <p id="additionalTxt">Чтобы завершить процесс подачи заявки, подтвердите условия займа</p>
    <div id="loanInfo">
      <div>
        <p>Сумма займа</p>
        <p class="dealNumbers">{{demandState.Amount | moneyFormat}} ₽</p>
      </div>
      <div>
        <p>Срок займа</p>
        <p v-if="demandState.period === 53" class="dealNumbers">{{demandState.period}} недель</p>
      </div>
      <div>
        <p>Еженедельный платеж</p>
        <p class="dealNumbers">{{demandState.FixedPay | moneyFormat}} ₽</p>
      </div>
    </div>

    <div class="boxes" v-if="boxArr.length > 0">
      <boxItem v-for="(item, index) in boxArr"
               :key="index"
               :index="index"
      ></boxItem>
    </div>

    <div id="requiredTxt">
      <p>В случае, если в таблице «Информация об услугах третьих лиц» мною проставлена отметка рядом с услугой, прошу перечислить часть займа в размере, составляющем стоимость дополнительной услуги, третьему лицу, предоставляющему соответствующую услугу. Я подтверждаю, что правила оказания услуг третьими лицами мне разъяснены и мною получены. Я уведомлен о том, что правила оказания третьими лицами услуг доступны в Личном кабинете заемщика. Я уведомлен о том, что приобретение услуг третьего лица не влияет на решение кредитора о предоставлении мне займа и на его условия. Я уведомлен о моем праве отказаться от услуги третьего лица в течение 30 календарных дней со дня выражения мною согласия на ее оказание посредством обращения к третьему лицу, оказывающему дополнительную услугу, с заявлением об отказе от такой услуги. Я также уведомлен, что вправе требовать от лица, оказывающего дополнительную услугу, возврата денежных средств, уплаченных за оказание такой услуги, за вычетом стоимости части такой услуги, фактически оказанной мне до дня получения лицом, оказывающим такую услугу, моего заявления об отказе от такой услуги. В случае, если третье лицо не исполняет обязанность по возврату мне денежных средств при отказе от дополнительной услуги, я вправе обратиться в ООО МКК «ФИНМОЛЛ» с заявлением о возврате денежных средств при отказе от дополнительной услуги.</p>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "instBoxConfirm",
  data(){
    return {}
  },
  components: {
    boxItem: () => import('@/components/inst/instBoxItem.vue')
  },
  computed:{
    ...mapState({
      demandState: state => state.instForm.demandState,
      boxArr:state => state.instForm.boxArr,
      clientInfo:state => state.instForm.clientInfo,
    }),
  },
  methods:{
    cdValue(valueobj){
      console.log(valueobj)
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
#requiredTxt{font-size: var(--font-size-12);color:var(--color-gray-type3);}
#additionalTxt{font-size: var(--font-size-14);}
#loanInfo{font-weight: 500}
#loanInfo div{padding: var(--font-size-16) 0;border-bottom: 1px solid var(--color-gray-type2);
display: flex;align-items: center;justify-content: space-between}
.dealNumbers{color:var(--color-green)}
</style>